import * as React from 'react';
import ReadEnvoyMessage from './ReadEnvoyMessage';
import OtherLinks from '../../components/OtherLinks';
import Footer from '../../components/Footer';
import PinTaskpaneHint from '../../components/PinTaskpaneHint';
import PortalIntegration from '../../PortalIntegration';
import Config from '../../Config';
import ReadMessageHelper from '../../ReadMessageHelper';

class ReadMessageProps {
}

class ReadMessageState {
    username: string;
    isEnvoyMessage?: boolean;
    isSender?: boolean;
    viewUrl?: string;
    hideHint?: boolean;
    error?: boolean;
}

export default class ReadMessage extends React.Component<ReadMessageProps, ReadMessageState> {

    constructor(props: ReadMessageProps) {
        super(props);

        var username = Config.getOverrideUsername() || Office.context.mailbox.userProfile.emailAddress;

        this.state = {
            username: username,
            isEnvoyMessage: null,
            isSender: false,
            viewUrl: null,
        };
    }

    componentDidMount() {

        Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, (e) => this._itemChanged(e));

        this.refreshItemState(Office.context.mailbox.item as Office.ItemRead);

    }

    render() {

        var content: JSX.Element;

        if (this.state.error) {
            content = <p>There was an error loading this message.</p>;
        }
        if (this.state.isEnvoyMessage == null) {
            content = <p>Loading...</p>;
        }
        else if (this.state.isEnvoyMessage == true) {
            content = <div>
                <ReadEnvoyMessage username={this.state.username} pickupUrl={this.state.viewUrl} isSender={this.state.isSender} />
                <h3 className="ms-font-xl">More Links</h3>
            </div>;
        }
        else if (this.state.isEnvoyMessage == false) {
            content = <p>The selected message is not<br />an encrypted email.</p>;
        }

        return <div className="ReadMessage ms-font-m ms-welcome">
            {this.state.hideHint ? null : <PinTaskpaneHint />}
            <div className="ms-u-slideDownIn20">
                <h2 className="ms-font-xxl">Encrypted Email</h2>
                {content}
                <OtherLinks username={this.state.username} />
            </div>
            <Footer />
        </div>;
    }

    private refreshItemState(item: Office.ItemRead) {

        var helper = new ReadMessageHelper();
        helper.loadAsync(item, (error?: any) => {

            try {
                if (error) {
                    this.setState({
                        error: true,
                    });
                }
                else if (helper.isEnvoyMessage()) {
                    var viewUrl: string = PortalIntegration.makeEmbeddedPickupUrl(this.state.username, helper.pickupId());
                    this.setState({
                        isEnvoyMessage: true,
                        isSender: helper.isSender(),
                        viewUrl: viewUrl,
                        error: false,
                    });
                }
                else {
                    this.setState({
                        isEnvoyMessage: false,
                        error: false,
                    });
                }
            }
            catch (e) {
                console.error(e);
                    this.setState({
                        error: true,
                    });
            }
        });
    }

    private _itemChanged(eventArgs: Office.EventType) {

        Config.setPinTaskpaneHintClosed(true);

        // clear state and trigger a refresh.
        this.setState({
            isEnvoyMessage: null,
            hideHint: true,
        });

        var item = (eventArgs as any).initialData;
        if (item == null) {
           return;
        }
        this.refreshItemState(item);
    }


}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/tasks/ReadMessage/ReadMessage.tsx